import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SignupUserService } from '@app/modules/signup-new/services/signup-user.service';
import { Logger } from '@app/shared/utils/lib/general.util';
import { distinctUntilChanged, filter, map } from 'rxjs';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    adroll?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __adroll?: any;
    __adroll_loaded?: boolean;
    adroll_adv_id?: string;
    adroll_pix_id?: string;
    adroll_version?: string;
  }
}

@Injectable({
  providedIn: 'root',
})
export class AddrollService {
  constructor(
    private signupUserService: SignupUserService,
    private router: Router
  ) {
    this.signupUserService.user$
      .pipe(
        map((user) => user?.email),
        filter((email) => !!email),
        distinctUntilChanged()
      )
      .subscribe((email) => {
        this.identify(email);
        this.recordUser();
      });

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) this.recordUser();
    });
  }

  load() {
    window.adroll_adv_id = '74QR6YTKQFGSPFDZRF5MBP';
    window.adroll_pix_id = 'ZIHLGOBA2ZBGZB452OINIP';
    window.adroll_version = '2.0';
    (function (w, d, e, o, a) {
      w.__adroll_loaded = true;
      w.adroll = w.adroll || [];
      w.adroll.f = ['setProperties', 'identify', 'track', 'identify_email', 'get_cookie'];
      const roundtripUrl = 'https://s.adroll.com/j/' + window.adroll_adv_id + '/roundtrip.js';
      for (a = 0; a < w.adroll.f.length; a++) {
        w.adroll[w.adroll.f[a]] =
          w.adroll[w.adroll.f[a]] ||
          (function (n) {
            return function () {
              // eslint-disable-next-line prefer-rest-params
              w.adroll.push([n, arguments]);
            };
          })(w.adroll.f[a]);
      }
      e = d.createElement('script');
      o = d.getElementsByTagName('script')[0];
      e.async = 1;
      e.src = roundtripUrl;
      o.parentNode.insertBefore(e, o);
    })(window, document);
    window.adroll.track('pageView');
  }

  private identify(email: string) {
    if (window.adroll?.identify_email) {
      Logger.log(`AddrollService: identify: ${email}`);
      window.adroll.identify_email(email);
    }
  }

  private recordUser() {
    if (window.__adroll?.record_user) {
      Logger.log('AddrollService: record');
      window.__adroll.record_user({});
    }
  }
}
